import {BioentitySummary} from 'folder-items/FileConstants';
import {entityIsContainable} from 'samples/containables/ContainableUtil';
import {StageRunSample} from 'workflows/WorkflowConstants';

/**
 * Checks whether the two samples represent the same batch or entity.
 *
 * Note that containerId field is ignored when checking similarity.
 */
export function areSimilar(stageRunSample1: StageRunSample, stageRunSample2: StageRunSample): boolean {
  if (stageRunSample1.id === stageRunSample2.id) {
    return true;
  }

  if (stageRunSample1.name !== stageRunSample2.name) {
    return false;
  }

  if (stageRunSample1.batch != null) {
    if (stageRunSample2.batch == null) {
      return false;
    }
    return stageRunSample1.batch.id === stageRunSample2.batch.id;
  }

  if (stageRunSample1.fileId != null) {
    return stageRunSample1.fileId === stageRunSample2.fileId;
  }

  // stageRunSample1 has been deleted or the user doesn't have access to the sample.
  // Make sure the other sample is deleted as well.
  return stageRunSample2.batch == null && stageRunSample2.fileId == null;
}

export function isContainable(
  stageRunSample: StageRunSample,
  bioentitySummary: BioentitySummary | null
): boolean {
  if (stageRunSample.fileId == null && stageRunSample.batch != null) {
    // Batches are always containable
    return true;
  }
  if (stageRunSample.fileId == null && stageRunSample.batch == null) {
    // Sample was deleted
    return true;
  }

  return Boolean(bioentitySummary && entityIsContainable(bioentitySummary));
}
